import { Link } from "react-router";
import styled from "styled-components";

import * as UI from "../../../../modules/ui-kit";
import SessionPersistentFiltersService from "../../app/SessionPersistentFiltersService";
import SessionStorageAdapter from "../../infrastructure/SessionStorageAdapter";
import ProductCardInExplorer from "../features/product-finder/ProductCardInExplorer";
import ProductFinder from "../features/product-finder/ProductFinder";

const persistentFiltersService = new SessionPersistentFiltersService(
    new SessionStorageAdapter(),
    "products-console:explorer",
);

export default function ProductExplorer() {
    return (
        <Styled>
            <NewProduct to="./Product/new">Add new product</NewProduct>
            <ProductFinder
                ProductComponent={ ProductCardInExplorer }
                persistentFiltersService={ persistentFiltersService }
            />
        </Styled>
    );
}

const Styled = styled.main`
    display: flex;
    flex-direction: column;
    gap: 8vh;
    padding: 8vh 16vw 12vh 12vw;
`;


const NewProduct = styled(UI.A).attrs({ $size: "large", as: Link })`
    align-self: flex-end;
`;
